import { Feature_Type_Config } from 'src/@types/graphql'
import { SupportedLocale } from 'src/@types'
import { Option } from 'src/shared/form/control'
import { PROCESS } from 'src/shared/constants/constants'

import { getTranslationForProcess } from 'src/screens/administration/configuration-management/ConfigurationUtils'

export const mapFeatureTypesToOptions = (
  featureTypes: Feature_Type_Config[],
  getMessage: (key: string, params?: Array<string | number>) => string,
  locale: SupportedLocale,
): Option[] =>
  featureTypes.map((ftc) => {
    if (ftc.active) {
      return {
        label: ftc.names[locale],
        value: ftc.id,
      }
    }

    const inactiveLabel = getMessage('label.inactive')
    return {
      label: (ftc.names[locale] || '') + ` (${inactiveLabel})`,
      value: ftc.id,
      disabled: true,
    }
  })

export const getFeaturesConfigProcessOptions = (
  getMessage: (key: string, params?: Array<string | number>) => string,
): Option[] => {
  return [
    { label: getTranslationForFeatureProcess(getMessage, PROCESS.PF_KAP), value: PROCESS.PF_KAP },
    { label: getTranslationForFeatureProcess(getMessage, PROCESS.PF_PGV), value: PROCESS.PF_PGV },
    { label: getTranslationForFeatureProcess(getMessage, PROCESS.KAP), value: PROCESS.KAP },
  ]
}

export const getTranslationForFeatureProcess = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  switch (value) {
    case 'KAP':
      return `${getMessage('label.process.KAP')}/${getMessage('label.process.FACTSHEET')}`
    default:
      return getTranslationForProcess(getMessage, value)
  }
}
